<template>
  <edit-team-profile-form
    :create="create"
    :team="computedTeam"
    :profiles="profiles"
    :state="state"
    :submitting="submitting"
    :active-tab="activeTab"
    @submit="onUpdateProfile"
  />
</template>

<script>
import EditTeamProfileForm from '@/components/forms/EditTeamProfileForm.vue'
import { toastError } from '@/helpers/helpers'

export default {
  name: 'EditTeamProfile',

  props: {
    team: {
      type: Object,
      default: () => ({})
    },

    create: {
      type: Boolean,
      default: false
    },

    profiles: {
      type: Object
    },

    profileMe: {
      type: Object
    },

    activeTab: {
      type: Number
    }
  },

  data() {
    return {
      submitting: false,
      state: {}
    }
  },

  computed: {
    computedTeam() {
      return !this.create
        ? this.team
        : {
          members: [{
            member: this.profileMe.id,
            profile: this.profileMe.id,
            isManager: true
          }]
        }
    }
  },

  methods: {
    async onUpdateProfile({ form, managemembers: { added, removed } }) {
      this.$emit('before-submit')
      this.submitting = true
      let teamId
      try {
        if (!this.create) {
          await this.$store.dispatch('updateTeam', { id: this.team.id, data: form })
          teamId = this.team.id
        } else {
          teamId = await this.$store.dispatch('createTeam', form)
        }

        const managemembers = [
          ...removed.map(id => this.$store.dispatch('deleteTeamMember', { teamId: teamId, memberId: id })),
          ...added.map(id => this.$store.dispatch('addTeamMember', { teamId: teamId, memberId: id }))
        ]

        await Promise.all(managemembers)

        if (managemembers.length > 0) {
          this.$store.dispatch('fetchTeam', teamId)
        }

        this.$emit('submitted')
      } catch (errors) {
        this.$emit('submit-failed')
        this.state = this.stateHandler(errors)
      } finally {
        this.submitting = false
      }
    },

    stateHandler(errors) {
      if (this.create && Array.isArray(errors)) {
        errors.forEach(error => toastError(this, error))
        return {}
      } else {
        return errors
      }
    }
  },

  components: {
    EditTeamProfileForm
  }
}
</script>
